module.exports = __webpack_public_path__ + "img/paylines-mid.6d7593c5.svg";